<mat-card appearance="outlined" style="text-align: center">
  <h3>Are you sure?</h3>
  <button mat-raised-button color="warn" (click)="onConfirmClick()">Confirm action</button>
  <button mat-button (click)="onCancelClick()">Cancel</button>
</mat-card>
